import { render, staticRenderFns } from "./schoolGradeManagementAdd.vue?vue&type=template&id=ba0bccb2&scoped=true&"
import script from "./schoolGradeManagementAdd.vue?vue&type=script&lang=js&"
export * from "./schoolGradeManagementAdd.vue?vue&type=script&lang=js&"
import style0 from "./schoolGradeManagementAdd.vue?vue&type=style&index=0&id=ba0bccb2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0bccb2",
  null
  
)

export default component.exports